import * as React from 'react';

import Spinner from './Spinner';
import PropTypes from 'prop-types';

/**
 * This component was created to delay the premature display
 * of "Not Found" messages that might show during slow javascript
 * execution.  Using it is an admission of suboptimal design choices :)
 * 
 * @param {number} delayMS -- MS delay before showing content
 * @param {element(s)} children -- The child nodes to display
 * @returns 
 */

const DelayContent = ({delayMS, children}) => {
  
  const [showContent, setShowContent] = React.useState(false);
  const delayRef = React.useRef(); 
  
  React.useEffect(() => {
    if(!showContent) {
      delayRef.current = window.setTimeout(() => {
        setShowContent(true);
      }, delayMS); 
    }
    return () => window.clearTimeout(delayRef.current);
  }, [delayMS, showContent]);
  
  return (
    <div>
      { showContent
        ? <>{ children }</>
        : <Spinner />
      }  
    </div> 
  );
};

DelayContent.propTypes = {
  delayMS: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.object,PropTypes.array]).isRequired
};

export default DelayContent;